import Reveal from "@/components/Reveal";
import { ClipboardList, Users, MapPin } from "lucide-react";

const STEPS = [
  {
    icon: ClipboardList,
    title: "Select the format.",
    body: "Select the event format you wish to attend as well as the slot.",
  },
  {
    icon: Users,
    title: "We match you, manually.",
    body: "Within a few hours, our team manually matches you into a verified small group.",
  },
  {
    icon: MapPin,
    title: "Meet your group.",
    body: "Get the plan, the place, and your people on WhatsApp. Show up. Make the memory.",
  },
];

export default function HowItWorks() {
  return (
    <section
      data-testid="how-it-works-section"
      className="bg-[#FDFBF7]"
    >
      <div className="max-w-md mx-auto md:max-w-6xl px-5 md:px-8 py-16 md:py-24 border-t border-[#E5E0D8]">
        <Reveal>
          <div className="text-[11px] md:text-xs uppercase tracking-[0.25em] font-semibold text-[#FF5A36]">
            How it works
          </div>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="mt-3 font-display font-extrabold text-3xl md:text-5xl leading-[1.05] tracking-tight text-balance max-w-3xl">
            Three steps. Then you just show up.
          </h2>
        </Reveal>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={100 + i * 100}>
                <div
                  data-testid={`step-${i + 1}`}
                  className="relative h-full rounded-3xl bg-white border border-[#E5E0D8] p-6 md:p-7 transition-all hover:-translate-y-1 hover:shadow-[0_20px_40px_-20px_rgba(255,90,54,0.25)]"
                >
                  <div className="flex items-center justify-between">
                    <span className="font-display font-black text-5xl md:text-6xl text-[#FF5A36]/60 leading-none">
                      0{i + 1}
                    </span>
                    <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-[#1A1A1A] text-white">
                      <Icon className="h-5 w-5" />
                    </span>
                  </div>
                  <h3 className="mt-6 font-display font-extrabold text-xl md:text-2xl tracking-tight text-[#1A1A1A]">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-[#5C5C5C] text-[15px] leading-relaxed">{s.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
